import React from "react";
import miiLogo from "../../../assets/images/mmiilogo.png";
import { footerOptions } from "../defaults";

const Footer = () => {
  return (
    <footer className="bg-white-900 flex md:justify-center">
      <div className="container mx-auto md:w-[90%] w-[98%] ">
        <div className="flex md:pl-4 md:justify-start justify-center mt-5">
          <a href="/Home" className="navbar-brand">
            <img src={miiLogo} alt="Logo" className="h-12" />
          </a>
        </div>
        <div className="flex justify-center">
          <div className="w-full grid md:grid-cols-4 grid-cols-2 md:justify-center justify-center text-gray-700 ">
            {footerOptions.map((section) => (
              <div className="flex w-full justify-start flex-col pl-4 mt-4">
                <span className="text-lg text-gray-600 font-bold">
                  {section.name}
                </span>
                <div className="mt-3">
                  <ul className="text-gray-600">
                    {section.options.map((option, index) => (
                      <li className="py-1 font-medium" key={index}>
                        {typeof option === "string" ? (
                          option
                        ) : (
                          <a
                            href={option.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-1000 hover:text-blue-500"
                          >
                            <div className="flex items-center">
                              {option.icon}
                              <span
                                className={
                                  section.name === "Social" ? "pl-2" : ""
                                }
                              ></span>
                              {option.name}
                            </div>
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-gray-700 flex md:justify-start justify-center my-10">
          <p>© 2024 MultiplyMii, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
